import { IProjectProfiles } from 'redux-store/api/projects';
import { IActivityFeedAudience } from 'redux-store/api/activity-feed';
import { IAudienceMembers, TConvertedAudience, TSourcedSpecificUser } from '../../../types';

export const isSpecificAudienceSelected = (
  profile: TSourcedSpecificUser,
  selectedAudience: TConvertedAudience
) => {
  const { source } = profile;
  return selectedAudience[source]?.some((item) => item.id === profile.id);
};

const isProjectProfile = (
  profiles: IActivityFeedAudience[] | IProjectProfiles[]
): profiles is IProjectProfiles[] => {
  return 'id' in profiles[0];
};

export const convertToMembers = (
  profiles: IActivityFeedAudience[] | IProjectProfiles[]
): IAudienceMembers['members'] => {
  if (isProjectProfile(profiles)) {
    return profiles.map((profile) => ({
      avatar: profile.avatar,
      firstName: profile.firstName,
      lastName: profile.lastName,
      id: profile.id,
    }));
  }

  return profiles.map((profile) => ({
    avatar: profile.avatar,
    firstName: profile.firstName,
    lastName: profile.lastName,
    id: profile.profileId,
  }));
};
